var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleOutlineOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus_states",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 20,
    height: 20,
    fill: "#8fda7b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#35ac25",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2129",
    "data-name": "Groupe 2129",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2128",
    "data-name": "Groupe 2128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_780",
    "data-name": "Trac\\xE9 780",
    d: "M8,14.5,14,10,8,5.5ZM10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0m0,18a8,8,0,1,1,8-8,8.011,8.011,0,0,1-8,8",
    fill: "#8fda7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleOutlineOutlined);
export default __webpack_public_path__ + "static/media/PlayCircleOutlineOutlined.728151e7093d0a37c09e0badfebc52c6.svg";
export { ForwardRef as ReactComponent };